import * as React from 'react'
import { fromJSX } from 'widgets-for-react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import type { DP } from '../../../drupal/blockDefinitions'
import { dummyData, randomTitle, randomWords } from '../../../utils/dummyData'
import { linkWrapper } from '../../../utils/link'
import type { ModernBlock, SeoEvent } from '../../modernBlocks.state'
import { textBlockClasses, TextBlockLayout } from './textBlock.layout'
import type { TextBlockProps } from './textBlock.state'

export const textBlock: ModernBlock<TextBlockProps, any, DP.Text> = {
  kind: 'textBlock',
  render: (setRootState, rootState, blockIndex, blockProps, amountNested) =>
    fromJSX((updateBlock) => (
      <TextBlockLayout.Inner id={`textblock-${blockIndex}`} amountNested={amountNested!}>
        <TextBlockLayout.Content
          label={blockProps.label}
          title={blockProps.title}
          intro={blockProps.intro}
          text={blockProps.text}
          showPrimary={blockProps.showPrimary}
          showSecondary={blockProps.showSecondary}
          primaryAction={blockProps.primaryAction!}
          secondaryAction={blockProps.secondaryAction!}
          showActionAsLink={blockProps.showActionAsLink}
        />
      </TextBlockLayout.Inner>
    )),
  adapters: {
    drupal: (dpBlock: DP.Text, blockIndex: number) => {
      const target = dpBlock.target.type[0].target_id
      if (target != 'text') return undefined
      return {
        title: dpBlock.target.field_title ? dpBlock.target.field_title[0]?.value : undefined,
        excludeFromPageMenu: dpBlock.target?.field_exclude_from_page_menu?.[0]?.value,
        text: dpBlock.target.field_body[0]?.processed,
        label: dpBlock.target.field_label ? dpBlock.target.field_label[0]?.value : undefined,
        intro: dpBlock.target.field_introduction ? dpBlock.target.field_introduction[0]?.value : undefined,
        showPrimary: dpBlock.target.field_links[0] ? true : false,
        showSecondary: dpBlock.target.field_links[1] ? true : false,
        primaryAction: linkWrapper({
          title: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.title! : '',
          url: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.processed_url! : '',
          anchor: dpBlock.target?.field_links ? dpBlock.target?.field_links[0]?.options?.attributes?.id! : '',
        }),
        secondaryAction: linkWrapper({
          title: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.title! : '',
          url: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.processed_url! : '',
          anchor: dpBlock.target?.field_links ? dpBlock.target?.field_links[1]?.options?.attributes?.id! : '',
        }),
        anchorTitle: dpBlock.target.field_title ? dpBlock.target.field_title[0]?.value : '',
        showActionAsLink: dpBlock.target.field_link_type[0]?.value == true ? true : false,
        inviewState: false
      }
    }
  },
  sampleExample: [
    {
      title: randomTitle(),
      label: randomWords(),
      intro: dummyData.intro,
      text: dummyData.typography,
      anchorTitle: 'text-sample-1',
      showPrimary: true,
      showSecondary: true,
      primaryAction: dummyData.primaryButton,
      secondaryAction: dummyData.secondaryButton,
      showActionAsLink: false
    }
  ],
  seoEvents: (props, blockIndex) =>
    [
      props.showPrimary && props.primaryAction
        ? {
            id: `primary_button`,
            event: 'onClick',
            category: 'text_block',
            label: window.location.pathname,
            action: 'primary_' + props.primaryAction.title
          }
        : undefined,
      props.showSecondary && props.secondaryAction
        ? {
            id: `secondary_button`,
            event: 'onClick',
            category: 'text_block',
            label: window.location.pathname,
            action: 'secondary_' + props.secondaryAction.title
          }
        : undefined
    ].filter((i) => i != undefined) as SeoEvent[],
  inView: {
    showAs: 'section',
    threshold: 0.1,
    triggerOnce: true,
    inViewClassName: getClassNameModern(textBlockClasses, 'inview', 'inview'),
    updateState: (currentInviewState, currentBlockState) => {
      return {
        ...currentBlockState,
        inviewState: currentInviewState
      }
    }
  },
  blockClassName: getClassNameModern(textBlockClasses, 'block', 'mb-6')
}
